import { createContext } from 'svelte'
import { TRANSLATIONS, type Locale, type Translations } from './translations'

export type TranslationKey = keyof Translations
type TagKeyOf<Key> = Key extends `tags.${infer TagKey}` ? TagKey : never
export type TagKey = TagKeyOf<TranslationKey>
export type TranslationVariables = Record<string, string | number>


export function translate(locale: Locale, key: TranslationKey, variables: TranslationVariables = {}): string {
  return TRANSLATIONS[locale][key].replace(/\{\{(\w+)\}\}/g, (placeholder, name: string) => (name in variables ? String(variables[name]) : placeholder))
}

export function switchLocalePath(url: string, locale: Locale): string {
  return url.replace(/^\/[^/?#]*/, `/${locale}`)
}

export class I18n {
  constructor(private readonly readLocale: () => Locale) {}

  get locale(): Locale {
    return this.readLocale()
  }

  t(key: TranslationKey, variables?: TranslationVariables): string {
    return translate(this.locale, key, variables)
  }

  path(path: string): string {
    return `/${this.locale}${path}`
  }
}

const [getI18nContext, setI18nContext, hasI18nContext] = createContext<I18n>()

export function setI18n(i18n: I18n): void {
  setI18nContext(i18n)
}

export function getI18n(): I18n {
  if (!hasI18nContext()) throw new Error('No i18n in context. Wrap this component in an I18nProvider.')

  return getI18nContext()
}
